export const BRAND_LOGO_PATH = "/suk-logo.png";

export function absoluteBrandLogoUrl(siteUrl) {
  return `${String(siteUrl).replace(/\/$/, "")}${BRAND_LOGO_PATH}`;
}
